import React, { useState } from 'react'
import { Modal, Select, Alert, Space, Tag, Typography, Card } from 'antd'
import { MergeOutlined } from '@ant-design/icons'

const { Text } = Typography

const MergeTableModalNoContext = ({
  sourceTableId,
  tables = [],
  getActiveBillsForTable,
  onMergeTables,
  getTableById,
  onClose,
}) => {
  const [targetTableId, setTargetTableId] = useState(null)
  const [merging, setMerging] = useState(false)

  const sourceTable = getTableById?.(sourceTableId)
  const sourceBills = getActiveBillsForTable?.(sourceTableId) || []

  const targetOptions = tables
    .filter((t) => String(t.id) !== String(sourceTableId))
    .map((t) => ({
      label: (
        <Space>
          {t.name}
          <Tag color={t.status === 'occupied' ? 'orange' : 'green'}>
            {t.status}
          </Tag>
        </Space>
      ),
      value: t.id,
    }))

  const handleMerge = async () => {
    if (!targetTableId) return

    setMerging(true)
    try {
      await onMergeTables(sourceTableId, targetTableId)
      onClose?.()
    } finally {
      setMerging(false)
    }
  }

  return (
    <Modal
      title={
        <Space>
          <MergeOutlined />
          Merge Table Bills
        </Space>
      }
      open={true}
      onCancel={onClose}
      onOk={handleMerge}
      okText={merging ? 'Merging…' : 'Merge Now'}
      okButtonProps={{
        disabled: !targetTableId || sourceBills.length === 0,
        loading: merging,
      }}
      width={460}
    >
      <Space direction="vertical" style={{ width: '100%' }} size={16}>
        {sourceBills.length === 0 ? (
          <Alert
            message="No active bills on this table to merge."
            type="error"
            showIcon
          />
        ) : (
          <Alert
            message={`All ${sourceBills.length} bill(s) from ${sourceTable?.name} will be moved to the target table.`}
            type="warning"
            showIcon
          />
        )}

        <Card size="small" title="Source Table" className="merge-card">
          <Text strong>{sourceTable?.name}</Text>
          <Tag style={{ marginLeft: 8 }}>{sourceTable?.zone}</Tag>
          <br />
          <Text type="secondary">{sourceBills.length} active bill(s)</Text>
        </Card>

        <div>
          <Text strong>Move to Table:</Text>
          <Select
            style={{ width: '100%', marginTop: 8 }}
            placeholder="Select target table..."
            value={targetTableId}
            onChange={setTargetTableId}
            options={targetOptions}
            size="large"
          />
        </div>
      </Space>
    </Modal>
  )
}

export default MergeTableModalNoContext